import './scripts/common';

let _config = window['_config'] || {};

// Todo: Add page specific JS here e.g:
import { startStimulusApp } from '@symfony/stimulus-bridge';
export const app = startStimulusApp(require.context(
    '@symfony/stimulus-bridge/lazy-controller-loader!./vue/components',
    true,
    /\.(j|t)sx?$/
));


import { registerVueControllerComponents } from '@symfony/ux-vue';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
registerVueControllerComponents(require.context('./vue/components', true, /\.vue$/, 'lazy'));

// NEEDED IF YOU USE PINIA

import {createPinia} from 'pinia';
document.addEventListener('vue:before-mount', (event) => {
    const {
        app,
    } = event.detail;

    const pinia = createPinia()
    pinia.use(piniaPluginPersistedstate);
    app.use(pinia);
});


import { onFind } from "@elements/init-modules-in-scope";
import Tooltip from 'bootstrap/js/dist/tooltip';

onFind('[data-bs-toggle="tooltip"]', (element) => {
    new Tooltip(element);
    const isMobile = matchMedia('(max-width: 767px)').matches;
    if (isMobile) {
        on('click', (e) => {
            e.preventDefault();
            e.stopPropagation(); // Stop the event from propagating to the stretch-link
        }, element);
    }
});


//console.log('product js');

import * as filterCounter from './scripts/filter-counter';
filterCounter.init();

import Collapse from 'bootstrap/js/dist/collapse';

import * as imageGallerySlider from './scripts/image-gallery-slider';
imageGallerySlider.init();

import * as imageSliderHero from './scripts/image-slider-hero';
imageSliderHero.init();

import * as teaserSliderLg from './scripts/teaser-slider-lg';
teaserSliderLg.init();

import * as productGrid from '@elements/product-grid';
productGrid.init({
    'mediaQuery': 'min-width'
});

import * as productGridCustomAddition from './scripts/product-grid-custom-addition';
productGridCustomAddition.init();


import * as tabs from './scripts/tabs';
tabs.init();

import * as asyncAppendViewport from './scripts/async-append-viewport';
import {on} from "@elements/dom-utils";
asyncAppendViewport.init();

